import { Component, Input, OnInit } from '@angular/core';
import { CallProgressState } from '../../../../samwebDescription/samweb/callHistory/callProgressState';

@Component({
   selector: 'samweb-call-progress-item',
   templateUrl: './call-progress-item.component.html',
   styleUrls: ['./call-progress-item.component.scss'],
})
export class CallProgressItemComponent implements OnInit {
   constructor() {}

   @Input()
   public callProgressState: CallProgressState;

   ngOnInit(): void {}
}
